import { DateTime } from "luxon";
import { getSpyLaunchMode } from "./getSpyLaunchMode";

export function spyLaunchSettingsConvertFromApiValue(spy: any){
     const spyLaunchMode = getSpyLaunchMode(spy)

        if (spyLaunchMode === 'sliding'){
            return {
                mode: 'sliding',
                params: {
                    daysAhead: spy.slidingPeriods.length
                }
            }       
        }

        if (spyLaunchMode === 'custom'){
            return {
                mode: 'custom',
                params: {
                    periods: [
                        {
                            startDate: DateTime.fromISO(spy.customPeriods[0].startDateTimeUtc).toUTC(),
                            endDate: DateTime.fromISO(spy.customPeriods[0].endDateTimeUtc).toUTC()
                        }
                    ]
                }
            }
        }
}